import React from "react";
export function SupportMessage() {
  return <div className="text-dark order-2 order-md-1">
    {/*<span className="text-muted font-weight-bold mr-2">{today.toString()}</span> &copy;{" "}
          <a
            href="http://keenthemes.com/metronic"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-75 text-hover-primary"
          >
            STRAC
          </a>*/}
    <span className="text-dark-75 font-weight-bold">
            Need help?
          </span>{" "}
    <span className="text-muted font-weight-bold mr-2">
            Call <a href="tel:2102335888">210-233-5888</a> or email&nbsp;<a href="mailto:support@texasrdc.org">support@texasrdc.org</a>
          </span>
  </div>
}